import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Autocomplete, TextField } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { GeoRehandleDTO } from "../../../DTOs/Geology/GeoRehandleDTO";
import { LocationDTO } from "../../../DTOs/Production/LocationDTO";

type MovementFromCellProps = {
  entry: GeoRehandleDTO,
  crushingMovementFromLocationOptions: LocationDTO[],
  isCrushingMovementFromLocationOptionsLoading: boolean
  handleUpdateRow: (row: GeoRehandleDTO) => Promise<boolean | undefined>
  isReadOnly: boolean
}

const MovementFromCell: React.FC<MovementFromCellProps> = ({
  entry,
  crushingMovementFromLocationOptions,
  isCrushingMovementFromLocationOptionsLoading,
  handleUpdateRow,
  isReadOnly
}) => {
  const { t } = useTranslation("geology");
  const [isLoading, setLoading] = useState(false);

  return (
    <Autocomplete
      disabled={isReadOnly}
      classes={{ root: 'w-full' }}
      size="small"
      loading={isCrushingMovementFromLocationOptionsLoading}
      options={crushingMovementFromLocationOptions}
      value={crushingMovementFromLocationOptions.find(x => x.id === entry.movementFromId) ?? null}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      getOptionLabel={(option) => option.name}
      onChange={async (_event, newValue) => {
        if (newValue) {
          setLoading(true);
          await handleUpdateRow(
            { ...entry, movementFromId: newValue.id }
          );
          setLoading(false);
        }
      }}
      renderInput={(params) => <TextField
        {...params}
        label={t("movement.movementFrom")}
        slotProps={{
          ...params.slotProps,
          input: {
            ...params.slotProps.input,
            endAdornment: (
              <>
                {(isLoading || isCrushingMovementFromLocationOptionsLoading) &&
                  <FontAwesomeIcon icon={faSpinner} spin />}
                {params.slotProps.input.endAdornment}
              </>
            )
          }
        }}
      />}
    />);
};

export default MovementFromCell;